import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import axios from 'axios';
import classNames from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { importStatic,isZippiaImage } from 'utils';
import { HttpRoutes } from 'utils/constant';

import { dispatchOpenArticlePopup } from '../store/modals/actions';
import withLazyLoadImages from '../utils/hocs/WithLazyLoadImages';

import classes from './ArticleCard.module.css';

const propTypes = {
  article: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    articleSlug: PropTypes.string,
    article_slug: PropTypes.string,
    post_type: PropTypes.oneOf(['popup']),
    freeDisplay: PropTypes.bool,
  }),
  onArticleClick: PropTypes.func,
  openInNew: PropTypes.object,
  customColumnClasses: PropTypes.string,
};

const defaultProps = {
  article: {
    image: '',
    title: '',
    articleSlug: '',
    article_slug: '',
    post_type: null,
    freeDisplay: false,
  },
  customColumnClasses: '',
};

const defaultAdviceImage = importStatic('/ui-router/images/default_advice_img_v2.png');

const ArticleCard = (props) => {
  const [opened, setOpened] = useState(false);

  const router = useRouter();
  const { asPath } = router;

  const { article, openInNew, dispatchOpenArticlePopup, onArticleClick, customColumnClasses, forwardedReference } =
    props;
  const { articleSlug, article_slug, image, title, post_type } = article;
  const articleCard = (
    <React.Fragment>
      <div className={classes.articleCardImgContainer} ref={forwardedReference}>
        {image ? (
          isZippiaImage(image) ? (
            <Image width="393" height="283" alt={title} src={image} />
          ) : (
            <img
              alt={title}
              src={image || defaultAdviceImage}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = defaultAdviceImage;
              }}
              width="393"
              height="283"
            />
          )
        ) : (
          <img alt={title} data-src={defaultAdviceImage} width="393" height="283" />
        )}
      </div>
      <div className={classNames(classes.articleCardText, 'articleCardText')}>
        <p className="companyPageSub">{title}</p>
        <p className={classNames(classes.articleCardPostedDate, 'semi-bold-font')} />
      </div>
    </React.Fragment>
  );

  const fetchArticle = async () => {
    if (!article.content && article_slug) {
      const { data } = await axios.get(HttpRoutes.getArticlesBySlug.format({ slug: article_slug }));

      if (data.length) return data[0];
    }

    return article;
  };

  const openArticle = async () => {
    const renderArticle = await fetchArticle();

    dispatchOpenArticlePopup(renderArticle);

    setOpened(true);
  };

  async function handleArticleClick(event, hash) {
    event.stopPropagation(); // Really this time.
    history.pushState(null, null, hash);
    if (onArticleClick) {
      onArticleClick();
    }

    openArticle();
  }

  useEffect(() => {
    if (window?.location?.hash.replace('#', '') === article_slug && !opened) {
      history.pushState(null, null, window.location.pathname);
      history.pushState(null, null, asPath);
      openArticle();
    }
  }, [article_slug, opened]);

  return (
    <Fragment>
      <div
        className={classNames(
          classes.articleCardWrapper,
          customColumnClasses || 'col-lg-4 col-md-6'
        )}
      >
        <div className={classes.articleCardContainer}>
          {post_type === 'popup' ? (
            <a
              className="blue-text"
              onClick={(e) => handleArticleClick(e, `${window.location.pathname}#${article_slug}`)}
            >
              {articleCard}
            </a>
          ) : (
            <a className="blue-text" {...openInNew} href={articleSlug || article_slug}>
              {articleCard}
            </a>
          )}
        </div>
      </div>
    </Fragment>
  );
};

ArticleCard.propTypes = propTypes;
ArticleCard.defaultProps = defaultProps;

const ArticleCardForwardRef = React.forwardRef((props, ref)=> <ArticleCard {...props} forwardedReference={ref}/>);

export default compose(
  withLazyLoadImages,
  connect(null, { dispatchOpenArticlePopup },null,  { forwardRef: true })
)(ArticleCardForwardRef);
